import React from 'react';
import { useState } from 'react';
import { nav } from '../../../utils/navigation';
import Search from '../../../images/search.svg';
import Button, { ButtonVariant } from '../../Button';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { PAGE } from '_constants/pages';
import cn from 'classnames';

interface ResultsNavigationProps {
  searchQuery?: any;
  setSearchQuery?: any;
  page?: string;
}

const ResultsNavigation: React.FC<ResultsNavigationProps> = props => {
  const { setSearchQuery, searchQuery, page } = props;
  const { language } = useI18next();
  const [currentType, setCurrentType] = useState<string>('');
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const searchPage =
    (page == PAGE.WEBINARS ? '/webinars/?s=' : '/blog/search?s=') + currentType;

  return (
    <div className={cn("relative rounded-md", page == PAGE.WEBINARS && "mr-2 md:mr-auto")}>
      {language === 'en-US' && (
        <div className="min-w-[50px]" onClick={() => setShowSearch(!showSearch)}>
          <Search className="absolute cursor-pointer top-1/2 left-3 -translate-y-1/2" />
        </div>
      )}
      <input
        className="h-full w-full pl-10 py-2 block md:hidden lg:block text-base rounded-lg border min-w-[120px] md:min-w-[278px] border-gray-4 focus:outline-none focus:border-indigo-1"
        placeholder="Search"
        value={currentType}
        onInput={e => {
          setCurrentType(e.currentTarget.value);
          if (!showSearch) {
            setShowSearch(true);
          }
        }}
        onKeyPress={e => {
          if (e.key === 'Enter') {
            setSearchQuery(currentType);
            nav(searchPage);
            setShowSearch(false);
            setCurrentType('');
          }
        }}
      />
      {showSearch && (
        <div className="absolute bottom-[44px] w-full bg-white p-4 border border-gray-4 rounded-xl min-w-[278px]">
          <div>
            <p className="w-full">
              <span className="text-gray-2 text-sm mr-1">Search:</span>
              <span className="inline-block w-full break-words">
                {currentType}
              </span>
            </p>
            <Button
              className="ml-auto text-sm flex"
              variant={ButtonVariant.tertiary}
              onClick={e => {
                setSearchQuery(currentType);
                nav(searchPage);
              }}
            >
              Show results<span className="pl-2 pt-1">↵</span>
            </Button>
          </div>
          <input
            className="h-full w-full pl-2 py-2 block lg:hidden text-base rounded-lg border border-gray-4 focus:outline-none focus:border-indigo-1"
            placeholder="Search"
            value={currentType}
            onInput={e => setCurrentType(e.currentTarget.value)}
            onKeyPress={e => {
              if (e.key === 'Enter') {
                setSearchQuery(currentType);
                nav(searchPage);
                setCurrentType('');
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ResultsNavigation;
